var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-cell-group',[_c('van-field',{attrs:{"label":"文本","placeholder":"请输入用户名"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }